import { fetchFinance } from "utils/api";
import { getAgent } from "utils/utils";

export const queryList = async (params) => {
  return await fetchFinance("/action", {
    action: "getDebitApply",
    debitStatus: "WAITING",
    sort: "created,desc",
    ...params,
  });
};

export const createDebitApplication = async (params) => {
  const agent = getAgent();
  return await fetchFinance("/action", {
    action: "addDebitApply",
    applicant: agent.email,
    ...params,
  });
};

export const approveOrRejectDebit = async (params) => {
  const agent = getAgent();
  return await fetchFinance("/action", {
    action: "approveDebitApply",
    reviewer: agent.email,
    ...params,
  });
};
